declare module PIXI {
	export interface DisplayObject {
		view: display.View,

		updateDisplay(renderer: display.Layer): void

		/**
		 * Stage will look inside for elements that can be re-arranged, if this flag is true
		 * Make it false for ParticleContainer
		 */
		layerableChildren: boolean;
	}

	export interface ObservablePoint {
		_x: number;
		_y: number;
	}

	export interface TransformBase {
		_parentID: number;
	}
}

(Object as any).assign(PIXI.DisplayObject.prototype, {
	layerableChildren: true,
	updateDisplay: function (layer: PIXI.display.Layer) {
		if (this.view) {
			if (this.view._activeParentLayer && this.view._activeParentLayer != layer) {
				return;
			}

			if (!this.visible || !layer) {
				this.view.layerOrder = 0;
			} else {
				this.view.layerOrder = layer.incDisplayOrder();
			}
		}
	}
});

if (PIXI.particles && PIXI.particles.ParticleContainer) {
	PIXI.particles.ParticleContainer.prototype.layerableChildren = false;
} else
if ((PIXI as any).ParticleContainer) {
	(PIXI as any).ParticleContainer.prototype.layerableChildren = false;
}
